/*
  Phone header and menu. See snippets/mobile-menu.liquid for what it does.
  The theme's own Menu button and its open/close code (theme.js) stay in
  charge; this watches the button's aria-expanded and, while it is open on a
  phone, shows the menu in its own side panel instead of the inline list.
*/
(function () {
  var PHONE = window.matchMedia('(max-width: 768px)');

  function init() {
    var trigger = document.getElementById('MobileNavTrigger');
    var nav = document.getElementById('MobileNav');
    if (!trigger || !nav) return;
    pinBar(trigger.parentNode);
    panel(trigger, nav);
  }

  /* ---------- Pinned bar ---------- */
  function pinBar(bar) {
    bar.classList.add('mm-bar');
    var tpl = document.getElementById('MobileMenuLogo');
    if (tpl && tpl.content) bar.appendChild(tpl.content.cloneNode(true));

    var spacer = document.createElement('div');
    spacer.className = 'mm-spacer';
    bar.parentNode.insertBefore(spacer, bar);

    var pinned = false;
    function check() {
      var top = (pinned ? spacer : bar).getBoundingClientRect().top;
      var want = PHONE.matches && top < 0;
      if (want === pinned) return;
      pinned = want;
      spacer.style.height = pinned ? bar.offsetHeight + 'px' : '';
      bar.classList.toggle('is-pinned', pinned);
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  /* ---------- Side panel ---------- */
  // The menu content comes from the theme's #MobileNav list, which Globo
  // fills with the live menu. On open it is read into a tree and shown as
  // slide-in levels (Outdoor -> Outdoor living -> links) with back arrows.
  // Globo headings left blank don't become a level: their links move up.
  function clean(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function linkOf(el) { var a = el && (el.matches('a[href]') ? el : el.querySelector('a[href]')); return a ? a.getAttribute('href') : ''; }

  function readTree(nav) {
    var items = [];
    Array.prototype.forEach.call(nav.children, function (li) {
      if (li.tagName !== 'LI' || li.classList.contains('mm-head')) return;
      var target = li.querySelector(':scope > a, :scope > .gm-target');
      var title = clean(li.querySelector(':scope > .gm-target .gm-text')) || clean(target);
      if (!title) return;
      var cs = getComputedStyle(li.querySelector(':scope > .gm-target .gm-text') || target || li);
      items.push({ title: title, url: linkOf(target), children: readChildren(li), color: cs.color, weight: cs.fontWeight });
    });
    // Items Globo gives their own colour (e.g. Seasonal, SALE) keep it: any
    // colour that differs from what most items use is copied onto the row.
    var count = {};
    items.forEach(function (it) { count[it.color] = (count[it.color] || 0) + 1; });
    var usual = Object.keys(count).sort(function (x, y) { return count[y] - count[x]; })[0];
    items.forEach(function (it) { if (it.color === usual) { delete it.color; delete it.weight; } });
    return items;
  }

  function readChildren(li) {
    var out = [];
    var lists = li.querySelectorAll('.gm-links');
    if (lists.length) {
      Array.prototype.forEach.call(lists, function (ul) {
        var head = ul.querySelector(':scope > .gm-heading');
        var links = [];
        Array.prototype.forEach.call(ul.children, function (c) {
          if (c === head || c.classList.contains('mm-all')) return;
          var t = clean(c.querySelector('a[href]')) || clean(c);
          if (t) links.push({ title: t, url: linkOf(c), children: [] });
        });
        var ht = clean(head);
        if (!ht) out.push.apply(out, links); // blank heading: its links move up
        else if (links.length) out.push({ title: ht, url: linkOf(head), children: links });
        else if (linkOf(head)) out.push({ title: ht, url: linkOf(head), children: [] }); // nothing under it: plain link
      });
      return out;
    }
    // Plain dropdowns (Globo) or the theme's own sublists.
    var sub = li.querySelector(':scope > .gm-submenu, :scope > ul, :scope > .mobile-nav__sublist');
    if (!sub) return out;
    var rows = sub.matches('ul') ? sub.children : sub.querySelectorAll(':scope > ul > li');
    Array.prototype.forEach.call(rows, function (c) {
      var a = c.querySelector(':scope > a, :scope > .gm-target');
      var t = clean(c.querySelector(':scope > .gm-target .gm-text')) || clean(a);
      var kids = readChildren(c), u = linkOf(a);
      if (t && (u || kids.length)) out.push({ title: t, url: u, children: kids });
    });
    return out;
  }

  function panel(trigger, nav) {
    var root = document.documentElement;
    var tpl = document.getElementById('MobileMenuLogo');

    var backdrop = document.createElement('div');
    backdrop.className = 'mm-backdrop';
    var drawer = document.createElement('div');
    drawer.className = 'mmd';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-label', 'Menu');
    drawer.innerHTML =
      '<div class="mmd__head"><div class="mmd__top"><span class="mmd__logo"></span>' +
      '<button type="button" class="mm-close" aria-label="Close menu">&times;</button></div>' +
      '<form class="mm-search" action="/search" method="get" role="search">' +
      '<input type="search" name="q" placeholder="Search" aria-label="Search"></form></div>' +
      '<div class="mmd__levels"></div>';
    document.body.appendChild(backdrop);
    document.body.appendChild(drawer);
    if (tpl && tpl.content) drawer.querySelector('.mmd__logo').appendChild(tpl.content.cloneNode(true));
    if (window.ahhPredictiveSearch) window.ahhPredictiveSearch.bind(drawer.querySelector('input'));
    var levels = drawer.querySelector('.mmd__levels');

    function close() { if (trigger.getAttribute('aria-expanded') === 'true') trigger.click(); }
    backdrop.addEventListener('click', close);
    drawer.querySelector('.mm-close').addEventListener('click', close);
    drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    var stack = [];
    function row(item) {
      var li = document.createElement('li');
      if (item.children.length) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mmd__row mmd__row--more';
        b.textContent = item.title;
        if (item.color) { b.style.color = item.color; b.style.fontWeight = item.weight; }
        b.addEventListener('click', function () { push(item); });
        li.appendChild(b);
      } else {
        var a = document.createElement('a');
        a.className = 'mmd__row';
        a.href = item.url || '#';
        a.textContent = item.title;
        if (item.color) { a.style.color = item.color; a.style.fontWeight = item.weight; }
        li.appendChild(a);
      }
      return li;
    }
    function level(item, isRoot) {
      var el = document.createElement('div');
      el.className = 'mmd__level';
      if (!isRoot) {
        var back = document.createElement('button');
        back.type = 'button';
        back.className = 'mmd__back';
        back.textContent = item.title;
        back.setAttribute('aria-label', 'Back from ' + item.title);
        back.addEventListener('click', pop);
        el.appendChild(back);
      }
      var ul = document.createElement('ul');
      ul.className = 'mmd__list';
      if (!isRoot && item.url) {
        ul.appendChild(row({ title: 'Shop all ' + item.title.toLowerCase(), url: item.url, children: [] }))
          .classList.add('mmd__all');
      }
      var kids = item.children;
      // Only one group under this section (e.g. Luxury brands -> Luxury
      // upholstery): show its links right here instead of one more tap.
      // Gift ideas is the exception: it keeps its own panel, and Gift cards
      // (if Globo has it inside Gift ideas) sits next to it instead (Waide).
      if (!isRoot && kids.length === 1 && /gift ideas/i.test(kids[0].title)) {
        var ideas = kids[0];
        var cards = ideas.children.filter(function (c) { return /gift card/i.test(c.title); });
        var rest = ideas.children.filter(function (c) { return cards.indexOf(c) < 0; });
        kids = [{ title: ideas.title, url: ideas.url, children: rest }].concat(cards);
      } else if (!isRoot && kids.length === 1 && kids[0].children.length) {
        var g = kids[0];
        ul.appendChild(row({ title: g.title, url: g.url, children: [] })).classList.add('mmd__group');
        kids = g.children;
      }
      kids.forEach(function (c) { ul.appendChild(row(c)); });
      el.appendChild(ul);
      return el;
    }
    function show() {
      Array.prototype.forEach.call(levels.children, function (el, i) {
        el.classList.toggle('is-current', i === stack.length - 1);
        el.classList.toggle('is-behind', i < stack.length - 1);
      });
      var cur = levels.children[stack.length - 1];
      if (cur) { cur.scrollTop = 0; var f = cur.querySelector('button, a'); if (f && stack.length > 1) f.focus({ preventScroll: true }); }
    }
    function push(item) {
      stack.push(item);
      levels.appendChild(level(item, false));
      requestAnimationFrame(show);
    }
    function pop() {
      if (stack.length < 2) return;
      stack.pop();
      var last = levels.lastElementChild;
      show();
      last.classList.add('is-leaving');
      setTimeout(function () { if (last.parentNode) last.parentNode.removeChild(last); }, 300);
    }
    function build() {
      var tree = { title: 'Menu', url: '', children: readTree(nav) };
      stack = [tree];
      levels.innerHTML = '';
      levels.appendChild(level(tree, true));
      show();
    }

    // Phones ignore overflow:hidden on the page, so scrolling the menu also
    // scrolled the page behind and dragged the menu's top out of view. Pin
    // the page in place while the menu is open and put it back on close.
    var savedY = 0;
    function lock(on) {
      var bs = document.body.style;
      if (on) {
        savedY = window.scrollY;
        bs.position = 'fixed'; bs.top = -savedY + 'px'; bs.left = '0'; bs.right = '0'; bs.width = '100%';
      } else {
        bs.position = bs.top = bs.left = bs.right = bs.width = '';
        window.scrollTo(0, savedY);
      }
    }
    var wasOpen = false;
    function sync() {
      var open = PHONE.matches && trigger.getAttribute('aria-expanded') === 'true';
      if (open === wasOpen) return;
      if (open) build();
      lock(open);
      root.classList.toggle('mm-open', open);
      wasOpen = open;
    }
    new MutationObserver(sync).observe(trigger, { attributes: true, attributeFilter: ['aria-expanded'] });
    PHONE.addListener ? PHONE.addListener(sync) : PHONE.addEventListener('change', sync);
  }

  // The search dropdown (assets/predictive-search.js) also lists menu
  // sections that match, read from this same tree.
  window.ahhMenu = {
    tree: function () {
      var nav = document.getElementById('MobileNav');
      return nav ? readTree(nav) : [];
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
